/**
 * eventType 当前支持类型
 * entryStr 进入事件
 * leaveStr 离开事件
 */
import {
    deepClone
} from '@/utils/util.js'
import $api from "@/common/api.js";
import $http from "@/common/request.js";

const paramsArr = ['/pages/index/index', '/plugins/pages/goods/detail', '/pages/user/index', '/plugins/pages/diy_page/detail'] // 不需要清除?后面的值
// 清除路径上的其他参数
function isClearParams(route) {
    const index = paramsArr.indexOf(route.path)
    if (route.path === '/') { // 首页可能出现/
        return route.fullPath
    }
    return index > 0 ? route.fullPath : route.path
}

function getUpdateTime(prevTime) {
    return (new Date().getTime() - prevTime) / 1000
}
export class Mta {
    constructor() {
        this.entryTime = new Date().getTime(); // 初始化
        this.startTime = new Date().getTime(); // 进入项目的初始时间
        this.flagTime = 10; // 总时间十秒更新一次
        this.updateTime = new Date().getTime(); // 距离上一次更新的时间
        this.pathRecordMap = Object.create(null); // 路径对应浏览时间
        this.shareData = null
    }
    // 浏览时长
    // 当前URL
    setEvent(eventType, route) {
        if (this[eventType]) {
            this[eventType](route)
        } else {
            console.warn("暂不支持该事件");
        }
    }

    entryStr(route) {
        this.entryTime = new Date().getTime();
    }

    leaveStr(route) {
        const entryTime = this.entryTime
        this.leaveTime = new Date().getTime();
        this.stayTime = this.leaveTime - entryTime; // 停留时间
        this.createRecordMap({
            route,
            stayTime: this.stayTime / 1000
        })
        this.update()
    }

    createRecordMap({
        route,
        stayTime
    }) {
		const fullPath = isClearParams(route) 
        const record = {
            page: route.path ,
            params: route.query,
            share_entry_num: 0,
            browse_time: parseInt(stayTime)
        }
		if( route.path === "/") return // 过滤掉 / 会被重定向到 /pages/index/index
        // 初始分享数据
        if (this.shareData) {
            record.share_entry_num = 1
        }
        // 累加
        if (this.pathRecordMap[fullPath]) {
            record.browse_time += this.pathRecordMap[fullPath].browse_time
        }
        this.pathRecordMap[fullPath] = record
    }

    clear() {
        this.pathRecordMap = Object.create(null);
        this.shareData = null;
    }

    update() {
        const updateTime = getUpdateTime(this.updateTime);
        const token = uni.getStorageSync('token')
        // if (updateTime >= this.flagTime && token) {
        //     this.updateTime = new Date().getTime(); // 更新一下上一次更新的时间
        //     $http.request({
        //         url: $api.default.buyingPoint,
        //         method: "POST",
        //         header: {
        //             contentType: 'application/x-www-form-urlencoded'
        //         },
        //         data: {
        //             form: JSON.stringify(deepClone(this.pathRecordMap))
        //         }
        //     }).then(res => {
        //         this.clear();
        //     })
        // }
        // 请求对应数据
    }

    pushShareData(params) {
        // 初始化分享
        this.shareData = params
    }

}